exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/coinevents/add-coin-events/add-coin-events.component.css
// module id = ../../../../../src/app/_components/coinevents/add-coin-events/add-coin-events.component.css
// module chunks = main